import { QueryClient } from '@tanstack/react-query';

export const ROUTES = {
  DETAILS: '/apps',
  FEATURED: '/',
  BROWSE: '/apps/browse',
  MANAGE: '/manage',
  PUBLISHER: '/publisher',
  ABOUT: '/about',
};

export const PREVIEW_ROUTES = {
  ec: ['/ec/:pluginType/:id/versions/:versionId/preview', '/ec/:pluginType/:id/preview'],
  cc: ['/cc/:pluginType/:id/versions/:versionId/preview', '/cc/:pluginType/:id/preview'],
  dc: ['/dc/:pluginType/:id/preview'],
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryDelay: 1000,
      retry: 1,
    },
  },
});

/**
 * @typedef {Object} FeatureFlag
 * @property {string} key
 * @property {string} client
 */

/** @type {Record<'SP_ISV', FeatureFlag>} */
export const FEATURED_FLAGS = Object.freeze({
  SP_ISV: {
    key: 'SP_ISV',
    client: 'IO_Developer_ARS',
  },
});

export const LINKS = {
  SP: { VIEW_DOCS: 'https://adobe.com/go/service-integration-applications' },
};
